import {
  OrderDocumentListParametersType,
  OrderDocumentListResponseType,
} from "@sellar-io/api-v2/types";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptionsV2,
} from "../apiV2Request";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { ServerStateKeys } from "../ServerStateKeys";
import { useInfiniteQuery } from "@tanstack/react-query";

export const useOrderDocumentList = <TData = OrderDocumentListResponseType,>(
  params: OrderDocumentListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [business?.id, ServerStateKeys.OrderDocument, params],
    queryFn: (queryParams) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `order-documents`,
        params: {
          ...params,
          offset: queryParams.pageParam,
        },
      }).then((response) => apiV2AssertResponse<TData>(response).data),
    ...getDefaultInfiniteQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: { ...options, limit: params.limit },
    }),
  });
};
